import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from './../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CommonDataService } from './../../../common-data.service';
import { LmTsService } from '../../lm-ts.service';
import { LambdaFunctionService } from '../../../../service/lambda-function.service';
import { Store } from '@ngrx/store';
import { CigSlideshowService } from '../../../cig/cig-slideshow.service';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
declare var toastr: any;

@Component({
  selector: "app-dynamic-card",
  templateUrl: "./dynamic-card.component.html",
  styleUrls: ["./dynamic-card.component.scss"],
})
export class DynamicCardComponent implements OnInit, OnDestroy {
  public profiles: any;
  @Input() map: any;
  @Input() active_card: string;
  public current_date: any;
  public env;
  public allcolumns: any;
  email: any = localStorage.getItem("email");
  cardQuery: String;
  @Input() markData: any;
  @Input() converseData: any;
  currentLM: string = "";
  currentLM_id: any;
  lm_maptype: string = "";
  author: any;
  slides: any;
  foursightassets: any;
  whatnext: string = "What's next?";
  appNoli: any;
  counter: number;
  allitem: any;
  sorted_item = [];
  printSlides = [];
  main_app_enable: boolean = false;
  cardView:boolean = false;
  cardDate4Admin:boolean = false;
  lmId:string;
  markedLoader:boolean = false;
  activityData:any;
  checkedCardIds:any = [];
  alphabets = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  private destroy$ = new Subject<void>();

  constructor(
    // private api: APIService,
    private service: CommonDataService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    public lm_ts: LmTsService,
    private router: Router,
    public lmda_service: LambdaFunctionService,
    public store: Store<any>,
    public cigService: CigSlideshowService
  ) {}

  placeholderImage = 'assets/images/learner-map-placeholder.svg';

  ngOnDestroy(): void {
    localStorage.setItem('adminDateVisible','false');
    this.destroy$.next();
    this.destroy$.complete();
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img && img.src !== this.placeholderImage) {
      img.src = this.placeholderImage;
    }
  }

  ngOnInit() {
    this.env = environment;
    this.appNoli = localStorage.getItem("appNoli");
    if (
      this.router.url.includes("fs-reveal") ||
      this.router.url.includes("profile-slideshow")
    ) {
      this.main_app_enable = true;
      if(this.router.url.includes('profile-slideshow') || this.router.url.includes('fs-reveal')) {
        // presenter-lm uses learner-maps card style (no Slideshow maptype)
        if (!this.router.url.includes('presenter-lm')) {
          this.lm_maptype = "Slideshow";
        }
        this.loadProfileData();
        this.loadPrintDataFromApi();
      }
    }
    if (this.router.url.includes("thinking-coach")) {
      this.lm_maptype = "Slideshow";
      this.loadPrintDataFromApi();
      this.store.select<any>((state) => state.profile.tcwaProfile).pipe(
        takeUntil(this.destroy$),
        filter(res => !!res)
      ).subscribe(res => {
        this.profiles = res['profile'];
      });
    }
    if(this.router.url.includes("fs-reveal/presenter-lm")) {
      this.appNoli = "false";
    }
    if(localStorage.getItem("adminDateVisible") == "true") {
      this.cardDate4Admin = true;
    }
    this.slides = this.cigService.slides;
    this.slides[1]["from"] = "from dynamic card";
    this.slides.forEach((sl)=> {
      delete sl["audio_link"]
    })
    this.slides.push(
      {
        id: 29, // for image but not title
        // title: this.currentlm?.title?.S,
        // imgLink: this.currentlm?.bg?.S,
        slideBackgroundImage: "",
        subtext: "",
        profileText: "",
        active: true,
      },
      {
        id: 30, // for video mp4
        // title: this.currentlm?.title?.S,
        // video_link: this.currentlm?.link?.S,
        slideBackgroundImage: "",
        // poster: this.currentlm?.bg?.S,
        subtext: "",
        profileText: "",
        active: true,
      },
      {
        id: 31, // for Wistia
        // title: this.currentlm?.title?.S,
        // video_link: this.currentlm?.link?.S,
        slideBackgroundImage: "",
        subtext: "",
        profileText: "",
        active: true,
      });
    this.author = {
      image: "author-pic.jpg",
      smallLogo: "foursight-grey-logo-logotype-trans-w160.png",
      logoicon: "foursight-grey-logo-icon.png",
      logotext: "foursight-grey-logo-text.png",
      logoFoursight: "foursight-grey-logo-logotype-trans-w846.png",
      audio: "",
      lm_audio: true,
    };

    this.foursightassets = {
      clarifyImage: "clarify-icon-2.png",
      titleClarify: "Clarify",
      ideateImage: "ideate-icon-2.png",
      titleIdeate: "Ideate",
      developImage: "develop-icon-2.png",
      titleDevelop: "Develop",
      implementImage: "impl-icon-2.png",
      titleImplement: "Implement",
    };
    $(document).on("mouseenter", ".start-work__cell", function () {
      $(".start-work__cell").removeClass("start-work__cell--active");
      $(this).addClass("start-work__cell--active");
      $(".dynamic-cards__overlay").addClass("dynamic-cards__overlay--show");
    });
    $(document).on("mouseleave", ".start-work__cell", function () {
      $(".start-work__cell").removeClass("start-work__cell--active");
      $(".dynamic-cards__overlay").removeClass("dynamic-cards__overlay--show");
    });

    if(this.router.url.includes('/challenge-navigator-print')){
      this.main_app_enable = true;
      this.cardView = true;
      this.appNoli = "false";
      this.lambda_lmdata();
          
    } else if(this.appNoli == "true"){
      this.lambda_lmdata();
      this.activatedRoute.params.subscribe((params: Params) => {
        var an_id = params.id;
        if(an_id && an_id != 'presenter-lm') {
          this.http.get(`${environment.profileURL}/api/v1/profiles/${an_id}.json`,{params:{profile:"custom",lang:"en"}}).subscribe(res => {
            this.profiles = res['profile'];
          })
        }
      })
    } else {
      this.appNoli = "false";
      this.current_date = new Date().getTime();

      this.store.select<any>((state) => state.profile?.account.default_profile).pipe(
        takeUntil(this.destroy$),
        filter(p => !!p)
      ).subscribe(profile => {
        this.profiles = profile;
      });

      // active card is bound via [class.card-active] in the template based on this.active_card input

      this.activatedRoute.params.pipe(
        takeUntil(this.destroy$)
      ).subscribe((params: Params) => {
        this.currentLM = '';
        if (this.currentLM_id != params['id']) {
          this.currentLM_id = params['id'];
          this.get_lm_activity();

          if (this.router.url.includes('/fs-reveal/presentation')) {
            this.http.get(`${environment.profileURL}/api/v1/learner_maps/68`).pipe(
              takeUntil(this.destroy$)
            ).subscribe((res: any) => {
              this.lm_maptype = res?.learner_map?.learner_map_type_title;
            });
          } else {
            const id = this.map?.learner_map?.id || this.map?.learner_map_id;
            if (id) {
              this.http.get(`${environment.profileURL}/api/v1/learner_maps/${id}`).pipe(
                takeUntil(this.destroy$)
              ).subscribe((lmRes: any) => {
                this.lm_maptype = lmRes?.learner_map?.learner_map_type_title;
                this.allcolumns = lmRes?.learner_map?.learner_map_columns;
                this.allcolumns?.forEach(column => {
                  column.learner_map_cards = column?.learner_map_cards?.filter(item => item.active !== false);
                });
              });
            }
          }
        }
      });

      // for presenter-lm
      if (this.router.url.includes('/fs-reveal/presenter-lm')) {
        this.main_app_enable = false;
        this.store.select<any>((state) => state.profile.accessGroupData).pipe(
          takeUntil(this.destroy$),
          filter(message => !!message)
        ).subscribe(message => {
          let presenterValue = message['main_menu']?.dynamic_lms?.presenter_lm?.value
          if(message?.main_menu?.profile?.profile_slideshow?.value) {
            this.http.get(`${environment.profileURL}/api/v1/learner_maps/${presenterValue}`).pipe(
              takeUntil(this.destroy$)
            ).subscribe((res: any) => {
              this.allcolumns = res.learner_map?.learner_map_columns;
            });
          }
        })
      }
    }
  }

  get_lm_activity() {
    if (!this.currentLM_id) return;
    this.http.get(`${environment.profileURL}/api/v1/users/learner_map_card_activities?learner_map_id=${this.currentLM_id}`).pipe(
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.activityData = res?.learner_map_card_activities;
      this.lm_ts.activityLM$.next(this.activityData);
    });
  }
 

  isCardIdExistInActivity(cardId) {
    let isExist = false;
    this.activityData && this?.activityData?.forEach((activity) => {
      if(activity.learner_map_card_id == cardId) {
        isExist = true;
      }
    })
    return isExist;
  }

  public activeCard(title = "") {
    if (this.lm_maptype === "Slideshow") {
      localStorage.setItem("lm_slideshow", title);
    }
  }

  public isActiveCard(record: any): boolean {
    if (!this.active_card || !record) return false;
    const recordId = record?.id?.S ?? record?.id;
    // Loose equality to handle string/number mismatch (URL gives string, API may give number)
    // eslint-disable-next-line eqeqeq
    return recordId == this.active_card;
  }

  public checkdate(time) {
    return new Date(time).getTime();
  }

  public verify_dates(bg_time, en_time) {
    if (bg_time || en_time) {
      return (
        (bg_time && this.checkdate(bg_time) > this.current_date) ||
        (en_time && this.checkdate(en_time) < this.current_date)
      );
    }
    return false;
  }

  public showError(error) {
    console.log("oops", error);
    if (error.status == 500) {
      setTimeout(function () {
        this.toastr.options = {
          closeButton: true,
          timeOut: 2000,
        };
        this.toastr.error("Something went wrong!", "Sorry!");
      }, 1000);
    } else if (error.status == 422) {
      setTimeout(function () {
        this.toastr.options = {
          closeButton: true,
          timeOut: 4000,
        };
        if (error.error.errors.number[0]) {
          this.toastr.error(error.error.errors.number[0], "oops!");
        }
        if (error.error.errors.base[0]) {
          this.toastr.error(error.error.errors.base[0], "oops!");
        }
        if (!error.error.errors.base[0] && !error.error.errors.number[0]) {
          this.toastr.error(error.error.errors, "oops!");
        }
      }, 1000);
    } else if (error.status == 404) {
      setTimeout(function () {
        this.toastr.options = {
          closeButton: true,
          timeOut: 4000,
        };
        this.toastr.error(error.error.errors, "oops!");
      }, 1000);
    } else {
      setTimeout(function () {
        this.toastr.options = {
          closeButton: true,
          timeOut: 2000,
        };
        this.toastr.error("Something went wrong!", "oops!");
      }, 1000);
    }
  }

  // Load default profile data for profile-slideshow route
  private loadProfileData() {
    this.store.select<any>((state) => state.profile?.account?.default_profile).pipe(
      takeUntil(this.destroy$),
      filter(p => !!p)
    ).subscribe(profile => {
      this.profiles = profile;
    });
  }

  // Load column data from API (pushed by fs-slideshow) and transform for slideshow-print.
  // Populates sorted_item (column structure for card view) and
  // printSlides (flat globally-ordered list for print view).
  private loadPrintDataFromApi() {
    this.lmda_service.lambda_res.pipe(
      takeUntil(this.destroy$),
      filter(res => !!res && Array.isArray(res) && res.length > 0)
    ).subscribe(columns => {
      // sorted_item: column structure with DynamoDB-format cards (for card column view)
      this.sorted_item = columns.map(col => ({
        ...col,
        cards: (col.learner_map_cards || col.cards || []).map(card => ({
          ...card,
          type: { S: card.kind || card.type?.S || '' },
          order: { N: (card.order || card.position || '').toString() },
          bg: { S: card.background || card.bg?.S || '' },
          text: { S: card.text?.S || card.text || '' },
          link: { S: card.link?.S || card.link || '' },
          title: { S: card.title?.S || card.title || '' }
        }))
      }));

      // printSlides: flatten all cards, sort by global order, wrap in single column
      const allCards = [];
      columns.forEach(col => {
        (col.learner_map_cards || col.cards || []).forEach(card => {
          allCards.push(card);
        });
      });
      allCards.sort((a, b) => {
        const orderA = parseInt(a.order || a.position || '0', 10);
        const orderB = parseInt(b.order || b.position || '0', 10);
        return orderA - orderB;
      });

      // Assign sequential nav indices to active cards so clicks stay in-bounds
      // even when card order values have gaps (e.g. order 1,2,3,5 skipping 4).
      const navIdxMap = new Map<string, number>();
      let navIdx = 0;
      allCards.forEach(c => {
        if (c?.active !== false && c?.active?.BOOL !== false) {
          navIdxMap.set((c?.id?.S || c?.id || '').toString(), navIdx++);
        }
      });
      this.sorted_item.forEach((col: any) => {
        (col.cards || []).forEach((card: any) => {
          const id = (card?.id?.S || card?.id || '').toString();
          if (navIdxMap.has(id)) {
            card._navIdx = navIdxMap.get(id);
          }
        });
      });

      const cards = allCards.map((card, idx) => ({
        ...card,
        type: { S: card.kind || card.type?.S || '' },
        order: { N: (card.order || card.position || (idx + 1)).toString() },
        bg: { S: card.background || card.bg?.S || '' },
        text: { S: card.text?.S || card.text || '' },
        link: { S: card.link?.S || card.link || '' },
        title: { S: card.title?.S || card.title || '' }
      }));
      this.printSlides = [{ cards }];
    });
  }

  // fetch learnerMap data using lambda function
  public lambda_lmdata(i = 0) {
    this.counter = i;
    this.lmda_service.lambda_res.pipe(
      takeUntil(this.destroy$)
    ).subscribe((res) => {
      let sorted = res["response"]?.body;
      let cardFormat = [];
      try {
        sorted.forEach((el) => {
          let index = parseInt(el?.order) - 1;
          this.sorted_item[index] = el;
          cardFormat[index] = el;
        });
      } catch (e) {
        return false;
      }

      this.sorted_item.forEach((col, ind) => {
        let sort_card = [];
        col["cards"].forEach((card) => {
          if (cardFormat[ind]?.cards) {
            cardFormat[ind].cards = [];
            sort_card[parseInt(card["order"]) - (col["cards"].length + 1)] = card;
          }
        });
        if (cardFormat[ind]?.cards) {
          cardFormat[ind]["cards"] = sort_card;
        }
      });
    });
  }

  // appNoli slide based on order
  public an_cards(orderNo,url) {
    this.lm_ts.an_slide_no.next(orderNo - 1);
    if(this.router.url.includes('challenge-navigator-print-coach')) {
      this.router.navigate([`challenge-navigator-print-coach/${url}`])
    }
  }

  public cardViewId(cardId) {
  }

  public async getLearnerMapColCard(lmId:string) {
    var that = this;
    let args = {
      lm_id: lmId,
      compName: "admin-single"
    }
    try {
      if (
        !this.router.url.includes("profile-slideshow") &&
        args.lm_id != "presentation"
      ) {
        await this.lmda_service.lambda_invoke(
          "read-dynamoDb-data",
          args
        );
      }
    } catch (err) {
      console.log(err);
    }
    this.lmda_service.lambda_res.pipe(
      takeUntil(this.destroy$)
    ).subscribe((res) => {
      if(res['response']?.body.length > 0) {
        let allcolumns:any = res["response"]?.body;
        allcolumns?.sort((a, b) => a?.order - b.order);
        allcolumns?.forEach((col) => {
          col.cards?.sort((a, b) => a?.order - b.order);
        })
        that.lmId = allcolumns[0]?.columnLearnermapId;
        that.allcolumns = allcolumns;
        that.map.columns = allcolumns;
      }
    })
  }

  markRead(record, event) {
    const member_id = localStorage.getItem('member_id');
    if (!member_id) return;

    this.markedLoader = true;
    const data: any = { member_id };

    this.http.post(`${environment.profileURL}/api/v1/learner_maps/${this.map.learner_map?.id}/learner_map_columns/${record?.learner_map_column_id}/learner_map_cards/${record?.id}/mark_read_by_member`, data).pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.markedLoader = false;
      this.get_lm_activity();
      toastr.options = { closeButton: true, progressBar: true, timeOut: 1000 };
      toastr.success(event.target.checked ? 'Card has been marked!' : 'Card is unmarked!');
    });
  }

  setLmDetails(column,card) {
  }

}